export default __webpack_public_path__ + "static/media/img8.a0df5579.PNG";